(function () {
  'use strict';
  const TIERS = Object.freeze([{ quantity: 2, percent: 5 }, { quantity: 4, percent: 7 }, { quantity: 6, percent: 9 }, { quantity: 8, percent: 10 }, { quantity: 15, percent: 12 }]);
  function offerTiers(value) {
    if (!Array.isArray(value) || !value.length || value.length > 8 || value.some((tier, index) => !Number.isInteger(tier.quantity) || tier.quantity < 1 || !Number.isInteger(tier.percent) || tier.percent < 1 || tier.percent > 100 || (index > 0 && (tier.quantity <= value[index - 1].quantity || tier.percent <= value[index - 1].percent)))) return TIERS;
    return value.map(tier => ({ quantity: tier.quantity, percent: tier.percent }));
  }
  const cleanVendor = value => String(value || '').toLowerCase().replace(/[\s-]/g, '');
  const id = value => Number.isSafeInteger(Number(value)) && Number(value) > 0 ? String(value) : '';
  const quantity = value => Number.isSafeInteger(Number(value)) ? Math.max(0, Math.min(99, Number(value))) : 0;
  const units = value => Number.isSafeInteger(Number(value)) && Number(value) >= 0 ? Number(value) : 0;
  function tierFor(count, tiers = TIERS) { return [...tiers].reverse().find(tier => count >= tier.quantity) || { quantity: 0, percent: 0 }; }
  function totals(lines, existing = [], tiers = TIERS) {
    const all = [...lines, ...existing];
    const count = all.reduce((sum, line) => sum + units(line.quantity), 0);
    const subtotal = all.reduce((sum, line) => sum + Math.max(0, Math.round(Number(line.price) || 0)) * units(line.quantity), 0);
    const tier = tierFor(count, tiers);
    const savings = all.reduce((sum, line) => sum + Math.floor(Math.max(0, Math.round(Number(line.price) || 0)) * tier.percent / 100) * units(line.quantity), 0);
    const next = tiers.find(candidate => candidate.quantity > count) || null;
    return { count, subtotal, savings, total: subtotal - savings, tier, next };
  }
  function validVehicle(row) {
    return row && row.verified === true && typeof row.id === 'string' && Number.isInteger(Number(row.year)) && Number(row.year) >= 1900 && Number(row.year) <= 2200 && ['make', 'model', 'engine', 'market', 'source_type_id'].every(key => typeof row[key] === 'string' && row[key].trim()) && safeOfficialUrl(row.source_url) && Array.isArray(row.recommendations);
  }
  function safeOfficialUrl(value) {
    try { const url = new URL(value); return url.protocol === 'https:' && (url.hostname === 'liqui-moly.com' || url.hostname.endsWith('.liqui-moly.com')); } catch { return false; }
  }
  function recommendationFor(vehicle, variant) {
    return vehicle?.recommendations?.find(row => row.verified === true && (!row.product_id || id(row.product_id) === id(variant.product?.id)) && safeOfficialUrl(row.source_url || vehicle.source_url) && ((id(row.variant_id) && id(row.variant_id) === id(variant.id)) || (String(row.sku || '').trim() && String(row.sku).trim() === String(variant.sku || '').trim()))) || null;
  }
  function additiveFor(vehicle, variant) {
    return typeof window !== 'undefined' ? window.SacLmAdditives?.evaluate(vehicle, variant) || null : null;
  }
  function selectionAllowed(vehicle, variant) {
    if (!vehicle) return true;
    if (['fuel', 'engine'].includes(variant?.product?.category)) return additiveFor(vehicle, variant)?.state !== 'incompatible';
    return !!recommendationFor(vehicle, variant);
  }
  function referencePriceCents(value, currency) {
    if (currency !== 'USD' || !['string','number'].includes(typeof value) || !/^(?:0|[1-9]\d*)(?:\.\d{1,2})?$/.test(String(value))) return null;
    const cents = Math.round(Number(value) * 100);
    return Number.isSafeInteger(cents) && cents > 0 ? cents : null;
  }
  function containerOptions(product, details) {
    const variants = new Map((product.variants || []).map(variant => [id(variant.id), variant]));
    const options = [], included = new Set();
    const verifiedDetails = details && safeOfficialUrl(details.source_url);
    const sourceRows = verifiedDetails && Array.isArray(details.container_options) ? details.container_options : [];
    for (const [index, row] of sourceRows.entries()) {
      if (!row || typeof row.content_label !== 'string' || !row.content_label.trim()) continue;
      const candidate = variants.get(id(row.variant_id));
      const retail = row.availability === 'retail' && candidate && candidate.price > 0 && (!row.sku || String(row.sku).trim() === String(candidate.sku || '').trim());
      if (retail && included.has(id(candidate.id))) continue;
      if (retail) included.add(id(candidate.id));
      options.push({ key: retail ? 'retail:' + id(candidate.id) : 'contact:' + index,
        label: row.content_label.trim().slice(0, 80), type: typeof row.type_label === 'string' ? row.type_label.slice(0, 120) : '',
        variantId: retail ? id(candidate.id) : null, sku: String(row.sku || '').slice(0, 80),
        sourceUrl: safeOfficialUrl(row.source_url) ? row.source_url : details.source_url,
        image: row.image_url || '', referencePrice: referencePriceCents(row.manufacturer_price, row.currency), contact: !retail });
    }
    for (const variant of variants.values()) {
      if (included.has(id(variant.id))) continue;
      options.push({ key: 'retail:' + id(variant.id), label: variant.title, type: '', variantId: id(variant.id), sku: variant.sku || '', sourceUrl: variant.source_url || product.source_url || '', image: variant.image || '', contact: false });
    }
    return options;
  }
  function groupContainerOptions(options) {
    const groups = new Map();
    for (const option of options) {
      const key = option.label.toLowerCase().replace(/\s/g, '');
      if (!groups.has(key)) groups.set(key, { key, label: option.label, options: [] });
      groups.get(key).options.push(option);
    }
    return [...groups.values()];
  }
  function categoryFor(product, previous) {
    const categories = ['oils', 'fuel', 'engine'];
    if (categories.includes(product.category)) return product.category;
    const tags = Array.isArray(product.tags) ? product.tags : typeof product.tags === 'string' ? product.tags.split(',').map(tag => tag.trim()) : [];
    const tagged = categories.find(value => tags.includes('lm-category-' + value));
    if (tagged) return tagged;
    const type = String(product.type || product.productType || '').trim().toLowerCase();
    const category = { 'motor oil': 'oils', 'fuel additive': 'fuel', 'oil additive': 'engine', 'engine cleaner': 'engine' }[type];
    return category || (categories.includes(previous) ? previous : 'other');
  }
  function unlockProgress(count, tiers = TIERS) {
    const value = Math.max(0, Number(count) || 0);
    let previous = 0;
    for (const [index, tier] of tiers.entries()) {
      if (value < tier.quantity) return (index + (value - previous) / (tier.quantity - previous)) * 100 / tiers.length;
      previous = tier.quantity;
    }
    return 100;
  }
  function parseVehicleReference(search) {
    try {
      const params = new URL(String(search), 'https://saccityautoparts.com').searchParams;
      const fields = { year: 'lm_year', make: 'lm_make', model: 'lm_model', engine: 'lm_type' };
      const reference = {};
      for (const [field, key] of Object.entries(fields)) {
        if (params.getAll(key).length !== 1 || !/^[1-9]\d*$/.test(params.get(key))) return null;
        reference[field] = id(params.get(key));
        if (!reference[field]) return null;
      }
      if (Number(reference.year) < 1900 || Number(reference.year) > new Date().getFullYear() + 1) return null;
      return reference;
    } catch { return null; }
  }
  function vehicleDestination(destination, vehicle, values) {
    try {
      const url = new URL(destination, 'https://saccityautoparts.com');
      if (url.origin !== 'https://saccityautoparts.com' || url.pathname.startsWith('//')) return '/pages/liqui-moly';
      const fields = { year: 'lm_year', make: 'lm_make', model: 'lm_model', engine: 'lm_type' };
      Object.values(fields).forEach(key => url.searchParams.delete(key));
      if (validVehicle(vehicle) && String(vehicle.year) === values?.year && vehicle.source_type_id === values?.engine && Object.keys(fields).every(field => id(values[field]))) {
        for (const [field, key] of Object.entries(fields)) url.searchParams.set(key, values[field]);
      }
      return url.pathname + url.search + url.hash;
    } catch { return '/pages/liqui-moly'; }
  }
  const pure = { offerTiers, parseVehicleReference, vehicleDestination, categoryFor, unlockProgress, tierFor, totals, validVehicle, recommendationFor, cleanVendor, quantity, safeOfficialUrl, containerOptions, groupContainerOptions, referencePriceCents };
  if (typeof module !== 'undefined' && module.exports) module.exports = pure;
  if (typeof window === 'undefined' || !window.customElements || customElements.get('sac-liqui-moly')) return;

  class SacLiquiMoly extends HTMLElement {
    connectedCallback() {
      if (this.started) return;
      this.started = true;
      try { this.config = JSON.parse(this.querySelector('[data-lm-config]').textContent); } catch { return; }
      this.controller = new AbortController();
      this.products = new Map();
      this.variants = new Map();
      this.selection = new Map();
      this.details = new Map();
      this.containerChoices = new Map();
      this.containerCache = new Map();
      this.eligible = new Set();
      this.existing = []; this.cartItems = [];
      this.vehicles = [];
      this.vehicle = null;
      this.category = 'all';
      this.preview = false;
      this.busy = false;
      this.uncertain = false;
      this.loaded = false;
      this.cartRead = null;
      this.cartRevision = 0;
      this.cartRefreshPending = false;
      this.cartRefreshTimer = null;
      this.currency = this.config.currency || 'USD';
      this.formatter = new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: this.currency });
      this.root = String(this.config.root || '/').replace(/\/?$/, '/');
      this.tiers = offerTiers(this.config.offer?.tiers);
      this.cartClient = window.SacLmCart?.configure({ root: this.root, currency: this.currency });
      this.service = this.querySelector('sac-liqui-service');
      customElements.whenDefined?.('sac-liqui-service').then(() => { if (this.isConnected && this.vehicle) this.service?.setVehicle?.(this.vehicle); });
      this.addProducts(this.config.products || []);
      this.addEventListener('click', event => this.onClick(event), { signal: this.controller.signal });
      this.addEventListener('change', event => this.onChange(event), { signal: this.controller.signal });
      this.addEventListener('sac:liqui-vehicle:changed', event => this.changeServiceVehicle(event), { signal: this.controller.signal });
      this.addEventListener('error', event => {
        if (!event.target.matches?.('.sac-lm__product-image img')) return;
        event.target.dataset.failedUrl = event.target.src; event.target.hidden = true;
        const placeholder = event.target.parentElement.querySelector('[data-lm-image-unavailable]'); if (placeholder) placeholder.hidden = false;
      }, { capture: true, signal: this.controller.signal });
      this.querySelector('[data-lm-vehicle-form]')?.addEventListener('submit', event => { event.preventDefault(); this.findVehicle(); }, { signal: this.controller.signal });
      for (const event of ['pageshow', 'focus']) window.addEventListener(event, () => this.requestCartRefresh(), { signal: this.controller.signal });
      document.addEventListener('sac:liqui-cart:updated', event => {
        if (!this.loaded || !event.detail?.cart) return;
        this.acceptCart(event.detail.cart); this.uncertain = !!event.detail.uncertain; this.render();
      }, { signal: this.controller.signal });
      document.addEventListener('sac:liqui-cart:state', event => {
        this.busy = !!event.detail?.busy; this.uncertain = !!event.detail?.uncertain;
        if (this.loaded) this.render();
        if (!this.busy && this.cartRefreshPending) this.requestCartRefresh();
      }, { signal: this.controller.signal });
      document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'visible') this.requestCartRefresh(); }, { signal: this.controller.signal });
      for (const event of ['on:cart:add', 'on:line-item:change', 'on:cart-drawer:before-open', 'on:bfcache:load-restore']) document.addEventListener(event, () => this.requestCartRefresh(), { signal: this.controller.signal });
      this.querySelector('[data-lm-dialog]')?.addEventListener('close', () => { this.detailOpener?.focus(); }, { signal: this.controller.signal });
      this.summaryMedia = window.matchMedia('(max-width: 749px)');
      this.summaryExpanded = false;
      this.summaryMedia.addEventListener('change', () => this.updateSummaryLayout(), { signal: this.controller.signal });
      this.addEventListener('keydown', event => {
        if (event.key !== 'Escape' || !this.summaryMedia.matches || !this.summaryExpanded || !event.target.closest('.sac-lm__summary')) return;
        event.preventDefault(); this.summaryExpanded = false; this.updateSummaryLayout(true);
      }, { signal: this.controller.signal });
      this.updateSummaryLayout();
      this.initialize();
    }
    disconnectedCallback() {
      this.liveGuide?.destroy(); this.controller?.abort();
      clearTimeout(this.cartRefreshTimer);
      this.cartRefreshTimer = null; this.cartRefreshPending = false; this.cartRead = null; this.loaded = false; this.started = false;
    }
    t(key, values = {}) {
      let output = this.config.strings?.[key] || key;
      Object.entries(values).forEach(([key, value]) => { output = output.split(`__${key.toUpperCase()}__`).join(String(value)); });
      return output;
    }
    money(cents) { return this.formatter.format(Math.max(0, cents) / 100); }
    updateSummaryLayout(returnFocus = false) {
      if (this.config?.compact) return;
      const summary = this.querySelector('.sac-lm__summary');
      const shopping = this.querySelector('.sac-lm__shopping');
      const body = this.querySelector('[data-lm-summary-body]');
      const toggle = this.querySelector('[data-lm-summary-toggle]');
      if (!summary || !shopping || !body || !toggle || !this.summaryMedia) return;
      const mobile = this.summaryMedia.matches;
      const expanded = !mobile || this.summaryExpanded;
      const active = document.activeElement;
      const hadFocus = summary.contains(active);
      const focusHidden = !expanded && body.contains(active);
      const moved = mobile ? shopping.firstElementChild !== summary : shopping.lastElementChild !== summary;
      if (moved) { if (mobile) shopping.prepend(summary); else shopping.append(summary); }
      this.dataset.lmSummaryEnhanced = 'true';
      body.hidden = !expanded;
      toggle.setAttribute('aria-expanded', String(expanded));
      this.querySelector('[data-lm-summary-toggle-label]').textContent = this.t(expanded ? 'hide_selection' : 'view_selection');
      this.querySelector('[data-lm-summary-toggle-icon]').textContent = expanded ? '−' : '+';
      if (mobile && (returnFocus || focusHidden)) toggle.focus({ preventScroll: true });
      else if (!mobile && active === toggle) this.querySelector('[data-lm-summary-title]')?.focus({ preventScroll: true });
      else if (moved && hadFocus && expanded) active?.focus({ preventScroll: true });
    }
    status(message) { const target = this.querySelector('[data-lm-status]'); if (target) target.textContent = message || ''; }
    safeAssetUrl(value) {
      try { const url = new URL(value, location.origin); return url.origin === location.origin || (url.protocol === 'https:' && (url.hostname === 'cdn.shopify.com' || url.hostname.endsWith('.myshopify.com'))); } catch { return false; }
    }
    safeImageUrl(value) {
      if (typeof value !== 'string' || !value.trim()) return '';
      try {
        const url = new URL(value, location.origin);
        return url.origin === location.origin || (url.protocol === 'https:' && ['cdn.shopify.com','www.liqui-moly.com','liquimoly.cloudimg.io','liqui-moly.px.media'].includes(url.hostname)) ? url.href : '';
      } catch { return ''; }
    }
    async json(url, options = {}) {
      const controller = new AbortController();
      const abort = () => controller.abort();
      this.controller.signal.addEventListener('abort', abort, { once: true });
      const timer = setTimeout(abort, 18000);
      try {
        const response = await fetch(url, { credentials: 'same-origin', ...options, signal: controller.signal });
        const result = await response.json();
        if (!response.ok) { const error = new Error(result.description || result.message || String(response.status)); error.httpStatus = response.status; throw error; }
        return result;
      } finally { clearTimeout(timer); this.controller.signal.removeEventListener('abort', abort); }
    }
    addProducts(products) {
      for (const product of products) {
        if (!id(product.id) || cleanVendor(product.vendor) !== 'liquimoly' || !Array.isArray(product.variants)) continue;
        const valid = product.variants.filter(variant => id(variant.id) && Number.isSafeInteger(variant.price) && variant.price > 0);
        if (!valid.length) continue;
        const category = categoryFor(product, this.products.get(id(product.id))?.category);
        const record = { ...product, category, image: product.image || product.featured_image, id: id(product.id), variants: valid };
        this.products.set(record.id, record);
        valid.forEach(variant => this.variants.set(id(variant.id), { ...variant, image: variant.image || variant.featured_image?.src, requiresSellingPlan: variant.requiresSellingPlan || product.requires_selling_plan, id: id(variant.id), product: record }));
      }
    }
    async initialize() {
      await Promise.allSettled([this.loadEligibility(), this.loadFitment(), this.loadPreview(), this.loadDetails()]);
      if (!this.isConnected) return;
      this.storageKey = `sac-liqui-moly-selection-v1:${this.config.collectionHandle}:${this.preview ? 'preview' : 'live'}`;
      // Previously staged bundles are never posted or counted as real cart items.
      try { sessionStorage.removeItem(this.storageKey); sessionStorage.removeItem(this.storageKey + ':filter'); } catch {}
      this.uncertain = !!this.cartClient?.state.uncertain;
      if (!this.preview) await this.loadCart();
      this.querySelectorAll('[data-lm-card]').forEach(card => this.prepareChooser(card));
      this.loaded = true;
      this.dataset.lmLoaded = 'true';
      if (this.config.compact) this.chooseQuickVariants();
      this.render();
      if (!this.preview && !this.cartClient) this.status(this.t('cart_unavailable'));
      if (this.liveGuide) {
        const reference = !this.config.compact && parseVehicleReference(location.href);
        const untouched = this.liveGuide.sequence === this.guideInitializedSequence;
        if (untouched && await this.liveGuide.restoreInitialGarage?.(reference)) return;
        if (reference && this.liveGuide.sequence === this.guideInitializedSequence) await this.liveGuide.restoreReference(reference);
        else if (this.fieldValues().engine && !this.vehicle) await this.liveGuide.find();
      }
    }
    async loadEligibility() {
      if (!this.safeAssetUrl(this.config.eligibilityUrl)) return;
      try {
        const manifest = await this.json(this.config.eligibilityUrl, { cache: 'no-store' });
        if (manifest.version !== 1 || manifest.collection_handle !== this.config.collectionHandle || manifest.status !== 'ready' || !Array.isArray(manifest.product_ids)) throw new Error('Invalid eligibility manifest');
        this.eligible = new Set(manifest.product_ids.map(id).filter(Boolean));
        this.manifestReady = this.eligible.size > 0;
      } catch { this.eligible.clear(); this.manifestReady = false; if (this.config.ready) this.status(this.t('manifest_error')); }
    }
    async loadPreview() {
      if (!this.config.previewEnabled || this.products.size || !this.safeAssetUrl(this.config.previewUrl)) return;
      try {
        const preview = await this.json(this.config.previewUrl);
        if (preview.version !== 1 || preview.status !== 'preview' || preview.currency !== this.currency || !safeOfficialUrl(preview.source_url) || !Array.isArray(preview.products)) return;
        this.preview = true;
        this.config.ready = false;
        this.addProducts(preview.products);
        this.previewEligible = new Set(this.products.keys());
        const list = this.querySelector('[data-lm-grid]');
        const template = this.querySelector('[data-lm-preview-template]');
        const count = 24;
        [...this.products.values()].slice(0, count).forEach(product => {
          if (!product.variants.length) return;
          const card = template.content.firstElementChild.cloneNode(true);
          card.dataset.productId = product.id;
          card.dataset.preview = '';
          card.dataset.category = ['oils','fuel','engine'].includes(product.category) ? product.category : 'other';
          card.querySelector('[data-lm-preview-title]').textContent = product.title.replace(/^LIQUI MOLY\s+/i, '');
          const image = card.querySelector('img');
          let imageUrl;
          try { imageUrl = new URL(product.image, location.origin); } catch { imageUrl = null; }
          if (imageUrl && (imageUrl.origin === location.origin || (imageUrl.protocol === 'https:' && ['cdn.shopify.com','www.liqui-moly.com','liquimoly.cloudimg.io','liqui-moly.px.media'].includes(imageUrl.hostname)))) { image.src = imageUrl.href; image.alt = product.title; } else image.remove();
          const select = card.querySelector('[data-lm-variant]');
          product.variants.forEach(variant => { const option = document.createElement('option'); option.value = variant.id; option.textContent = variant.title; select.append(option); });
          select.setAttribute('aria-label', this.t('choose_size'));
          if (product.variants.length === 1) select.hidden = true;
          const link = card.querySelector('[data-lm-source]');
          if (link) { if (safeOfficialUrl(product.source_url)) link.href = product.source_url; else link.remove(); }
          list.append(card);
        });
        this.querySelector('[data-lm-preview-banner]').hidden = false;
        this.querySelector('[data-lm-empty]').hidden = this.products.size > 0;
        this.querySelector('[data-lm-setup]').textContent = this.t('preview_only');
      } catch { this.status(this.t('preview_error')); }
    }
    async loadDetails() {
      if (!this.config.detailsUrl || !this.safeAssetUrl(this.config.detailsUrl)) return;
      try {
        const data = await this.json(this.config.detailsUrl);
        if (data.version !== 1 || !data.products || Array.isArray(data.products) || typeof data.products !== 'object') return;
        for (const [productId, detail] of Object.entries(data.products)) {
          if (id(productId) && detail && safeOfficialUrl(detail.source_url)) this.details.set(id(productId), detail);
        }
      } catch { /* Native variants and official product links remain available. */ }
    }
    optionsFor(product) {
      if (!this.containerCache.has(product.id)) this.containerCache.set(product.id, containerOptions(product, this.details.get(product.id)));
      return this.containerCache.get(product.id);
    }
    currentContainer(view) {
      const product = this.products.get(view.dataset.productId);
      if (!product) return null;
      const options = this.optionsFor(product);
      const chosen = this.containerChoices.get(product.id);
      if (chosen) return options.find(option => option.key === chosen) || null;
      const nativeId = id(view.querySelector('[data-lm-variant]')?.value || product.variants.find(variant => variant.available)?.id || product.variants[0]?.id);
      return options.find(option => option.variantId === nativeId) || options.find(option => option.variantId) || options[0] || null;
    }
    prepareChooser(view) {
      const product = this.products.get(view.dataset.productId);
      const target = view.querySelector('[data-lm-container-options]');
      if (!product || !target) return;
      const options = this.optionsFor(product), selected = this.currentContainer(view);
      if (selected && !this.containerChoices.has(product.id)) this.containerChoices.set(product.id, selected.key);
      target.replaceChildren();
      const scope = view.matches('[data-lm-product-panel]') ? 'detail' : 'card';
      const retail = options.filter(option => !option.contact), other = options.filter(option => option.contact);
      const appendOption = (option, destination) => {
        const label = document.createElement('label'); label.className = 'sac-lm__container-pill';
        if (option.contact) label.classList.add('is-contact');
        const input = document.createElement('input'); input.type = 'radio'; input.name = `${this.id}-${scope}-${product.id}-container`;
        input.value = option.key; input.dataset.lmContainerChoice = ''; input.dataset.productId = product.id;
        input.checked = option.key === selected?.key;
        const text = document.createElement('span');
        const repeatedSize = options.filter(item => item.label.toLowerCase().replace(/\s/g, '') === option.label.toLowerCase().replace(/\s/g, '')).length > 1;
        text.textContent = option.label + (option.contact && repeatedSize && option.sku ? ' · ' + option.sku : '');
        label.append(input, text);
        if (option.contact) { const note = document.createElement('span'); note.className = 'sac-lm__visually-hidden'; note.textContent = ' · ' + this.t('contact_availability'); label.append(note); }
        destination.append(label);
      };
      retail.forEach(option => appendOption(option, target));
      if (other.length) {
        const disclosure = document.createElement('details'); disclosure.className = 'sac-lm__other-sizes'; disclosure.open = !!selected?.contact;
        const heading = document.createElement('summary'); heading.textContent = this.t('other_sizes');
        const choices = document.createElement('div'); choices.className = 'sac-lm__other-options';
        other.forEach(option => appendOption(option, choices));
        disclosure.append(heading, choices); target.append(disclosure);
      }
      view.querySelector('[data-lm-chooser]').hidden = !options.length;
      const native = view.querySelector('[data-lm-variant]'); if (native && options.length) native.hidden = true;
    }
    chooseContainer(productId, key) {
      const product = this.products.get(id(productId));
      if (!product || this.busy || this.uncertain || !this.optionsFor(product).some(option => option.key === key)) return;
      this.containerChoices.set(product.id, key);
      this.render();
    }
    openDetails(view, opener) {
      const product = this.products.get(view.dataset.productId), dialog = this.querySelector('[data-lm-dialog]');
      if (!product || !dialog || typeof dialog.showModal !== 'function') return false;
      const panel = dialog.querySelector('[data-lm-product-panel]');
      panel.dataset.productId = product.id;
      panel.querySelector('[data-lm-detail-title]').textContent = product.title;
      this.populateDetails(panel, product);
      this.prepareChooser(panel);
      this.detailOpener = opener;
      this.render();
      if (!dialog.open) dialog.showModal();
      panel.querySelector('[data-lm-detail-title]').focus();
      return true;
    }
    populateDetails(panel, product) {
      const detail = this.details.get(product.id), content = panel.querySelector('[data-lm-detail-content]');
      content.replaceChildren();
      const appendSection = (heading, values, open = false) => {
        const rows = (Array.isArray(values) ? values : [values]).filter(value => typeof value === 'string' && value.trim());
        if (!rows.length) return;
        const section = document.createElement('details'); section.className = 'sac-lm__detail-section'; section.open = open;
        const summary = document.createElement('summary'); summary.textContent = this.t(heading); section.append(summary);
        const list = document.createElement(rows.length > 1 ? 'ul' : 'div');
        rows.forEach(value => { const text = document.createElement(rows.length > 1 ? 'li' : 'p'); text.textContent = value; list.append(text); });
        section.append(list); content.append(section);
      };
      if (!detail) appendSection('detail_description', this.t('details_fallback'), true);
      else {
        appendSection('detail_description', detail.description, true);
        if (typeof detail.manufacturer_claims_note === 'string' && detail.manufacturer_claims_note.trim()) { const note = document.createElement('p'); note.className = 'sac-lm__catalog-note'; note.textContent = detail.manufacturer_claims_note; content.append(note); }
        appendSection('detail_qualities', (detail.qualities || []).map(row => typeof row === 'string' ? row : row.text), true);
        appendSection('detail_approvals', detail.specifications);
        appendSection('detail_recommendations', detail.recommendations);
        appendSection('detail_spec_notes', detail.specification_notes, true);
        appendSection('detail_applications', detail.applications);
        appendSection('detail_instructions', detail.instructions);
        appendSection('detail_cautions', detail.cautions);
        const documents = (detail.documents || []).filter(row => row && safeOfficialUrl(row.url));
        if (documents.length) {
          const links = document.createElement('div'); links.className = 'sac-lm__detail-documents';
          documents.forEach(row => { const link = document.createElement('a'); link.href = row.url; link.target = '_blank'; link.rel = 'noopener'; link.textContent = row.label || this.t('manufacturer_details'); links.append(link); });
          content.append(links);
        }
      }
    }
    async loadFitment() {
      if (window.SacLmGuide) {
        this.liveGuide = window.SacLmGuide.create(this);
        await this.liveGuide.initialize();
        this.guideInitializedSequence = this.liveGuide.sequence;
        return;
      }
      if (!this.safeAssetUrl(this.config.fitmentUrl)) { this.enableGuideHandoff(); return; }
      try {
        const data = await this.json(this.config.fitmentUrl);
        if (data.version !== 1 || data.status !== 'verified' || !Array.isArray(data.vehicles)) return;
        this.vehicles = data.vehicles.filter(validVehicle);
        if (!this.vehicles.length) return;
        this.setFieldOptions('year', [...new Set(this.vehicles.map(row => String(row.year)))].sort((a,b) => Number(b) - Number(a)));
        this.finderStatus(this.t('fitment_ready'));
      } catch { this.finderStatus(this.t('guide_fallback')); }
      finally { if (!this.vehicles.length) this.enableGuideHandoff(); }
    }
    enableGuideHandoff() {
      if (this.config.compact) { this.finderStatus(this.t('guide_live_error')); return; }
      this.handoffMode = true;
      this.querySelectorAll('[data-lm-field]').forEach(field => {
        const input = document.createElement('input');
        input.id = field.id; input.dataset.lmField = field.dataset.lmField;
        input.type = field.dataset.lmField === 'year' ? 'number' : 'text';
        input.required = field.dataset.lmField !== 'engine';
        input.autocomplete = 'off'; input.maxLength = 80;
        if (input.type === 'number') { input.min = '1900'; input.max = String(new Date().getFullYear() + 1); input.inputMode = 'numeric'; }
        field.replaceWith(input);
      });
      const button = this.querySelector('[data-lm-find]'); button.disabled = false; button.firstChild.textContent = this.t('search_guide') + ' ';
      this.finderStatus(this.t('guide_handoff'));
    }
    finderStatus(message) { const target = this.querySelector('[data-lm-finder-status]'); if (target) target.textContent = message; }
    setFieldOptions(name, values) {
      const field = this.querySelector(`[data-lm-field="${name}"]`);
      if (!field) return;
      field.replaceChildren();
      const placeholder = document.createElement('option'); placeholder.value = ''; placeholder.textContent = this.t('choose'); field.append(placeholder);
      values.forEach(value => { const option = document.createElement('option'); option.value = typeof value === 'object' ? value.value : value; option.textContent = typeof value === 'object' ? value.label : value; field.append(option); });
      field.disabled = values.length === 0;
    }
    setFieldValue(name, value) {
      const field = this.querySelector(`[data-lm-field="${name}"]`);
      if (!field || field.disabled || ![...field.options].some(option => option.value === String(value))) return false;
      field.value = String(value); return true;
    }
    setGuideBusy(busy) {
      this.querySelector('[data-lm-finder]')?.setAttribute('aria-busy', String(busy));
      this.querySelector('[data-lm-grid]')?.setAttribute('aria-busy', String(busy));
    }
    fieldValues() { return Object.fromEntries([...this.querySelectorAll('[data-lm-field]')].map(field => [field.dataset.lmField, field.value])); }
    changeVehicleField(name) {
      this.liveGuide?.garageFieldChanged?.(name);
      this.service?.clearVehicle?.();
      if (this.liveGuide) { this.liveGuide.change(name); return; }
      if (this.handoffMode) return;
      this.vehicle = null;
      this.querySelector('[data-lm-vehicle-result]').hidden = true;
      const fields = ['year','make','model','engine'];
      const index = fields.indexOf(name);
      fields.slice(index + 1).forEach(field => this.setFieldOptions(field, []));
      const values = this.fieldValues();
      const matches = this.vehicles.filter(row => fields.slice(0, index + 1).every(field => String(row[field]) === values[field]));
      const next = fields[index + 1];
      if (next === 'engine') this.setFieldOptions(next, matches.map(row => ({ value: row.id, label: row.engine })));
      else if (next) this.setFieldOptions(next, [...new Set(matches.map(row => row[next]))].sort());
      this.querySelector('[data-lm-find]').disabled = !this.fieldValues().engine;
      this.render();
    }
    findVehicle() {
      this.liveGuide?.garageFieldChanged?.('engine');
      this.service?.clearVehicle?.();
      if (this.liveGuide) { this.liveGuide.find(); return; }
      const values = this.fieldValues();
      if (this.handoffMode) {
        if (!this.querySelector('[data-lm-vehicle-form]').reportValidity() || !safeOfficialUrl(this.config.guideUrl)) return;
        const query = [values.year, values.make, values.model, values.engine, 'USA'].map(value => String(value || '').trim().slice(0,80)).filter(Boolean).join(' ');
        const encode = value => btoa(String.fromCharCode(...new TextEncoder().encode(value)));
        const guide = new URL(this.config.guideUrl); guide.searchParams.set('searchText', encode(query)); guide.searchParams.set('tabName', encode('textSearch'));
        window.open(guide.href, '_blank', 'noopener');
        return;
      }
      this.vehicle = this.vehicles.find(row => row.id === values.engine && String(row.year) === values.year && row.make === values.make && row.model === values.model) || null;
      if (!this.vehicle) { this.finderStatus(this.t('fitment_none')); return; }
      this.querySelector('[data-lm-vehicle-name]').textContent = `${this.vehicle.year} ${this.vehicle.make} ${this.vehicle.model} · ${this.vehicle.engine}`;
      this.querySelector('[data-lm-vehicle-notes]').textContent = this.vehicle.notes || '';
      this.querySelector('[data-lm-vehicle-source]').href = this.vehicle.source_url;
      this.querySelector('[data-lm-vehicle-result]').hidden = false;
      this.finderStatus(this.t('fitment_found'));
      this.render();
    }
    applyGuideVehicle() {
      this.service?.setVehicle?.(this.vehicle);
      this.category = 'all';
      for (const product of this.products.values()) {
        const options = this.optionsFor(product);
        const current = options.find(option => option.key === this.containerChoices.get(product.id));
        if (current?.variantId && this.canSelect(this.variants.get(current.variantId)) && recommendationFor(this.vehicle, this.variants.get(current.variantId))) continue;
        const match = options.find(option => option.variantId && this.canSelect(this.variants.get(option.variantId)) && recommendationFor(this.vehicle, this.variants.get(option.variantId)));
        if (match) this.chooseContainer(product.id, match.key);
      }
      this.summaryExpanded = false;
      this.updateSummaryLayout();
      this.render();
    }
    guideResultStatus(vehicle) {
      if (this.config.compact) return false;
      const oils = new Set(vehicle.recommendations.filter(row => row.kind === 'oil').map(row => String(row.product_id))).size;
      const additives = [...this.products.values()].filter(product => ['fuel', 'engine'].includes(product.category) && product.variants.some(row => { const variant = this.variants.get(id(row.id)); return this.canSelect(variant) && selectionAllowed(vehicle, variant); })).length;
      this.finderStatus(this.t('additive_results_summary', { oils, additives }));
      return true;
    }
    vehicleProperties(vehicle, variant, offer = {}) {
      const isAdditive = ['fuel', 'engine'].includes(variant?.product?.category);
      const properties = window.SacLmService?.buildVehicleProperties(vehicle, isAdditive ? {} : { filterRequested: offer.withFilter, oilMatch: recommendationFor(this.vehicle, variant) ? 'listed' : 'unverified' }) || {};
      if (vehicle && isAdditive) Object.assign(properties, window.SacLmAdditives?.properties(additiveFor(vehicle, variant)) || { 'Additive application': 'Application needs confirmation' });
      if (!isAdditive && offer.oilAcknowledged) properties['Oil fitment review'] = 'Customer acknowledged that oil compatibility needs team confirmation';
      return properties;
    }
    quickProducts() {
      return [...this.products.values()].filter(product => product.category === 'oils').map(product => {
        const variants = product.variants.map(variant => this.variants.get(id(variant.id))).filter(variant => this.canSelect(variant) && (!this.vehicle || recommendationFor(this.vehicle, variant)));
        return { product, variants };
      }).filter(row => row.variants.length > 0);
    }
    chooseQuickVariants() {
      for (const { product, variants } of this.quickProducts()) {
        const current = this.optionsFor(product).find(option => option.key === this.containerChoices.get(product.id));
        if (variants.some(variant => variant.id === current?.variantId)) continue;
        const option = this.optionsFor(product).find(item => variants.some(variant => variant.id === item.variantId));
        if (option) this.chooseContainer(product.id, option.key);
      }
    }
    requestCartRefresh() {
      if (!this.loaded || this.preview || !this.isConnected) return;
      this.cartRefreshPending = true;
      if (this.cartRead) this.cartRevision = (this.cartRevision || 0) + 1;
      if (this.busy || this.cartRead || this.cartRefreshTimer) return;
      this.cartRefreshTimer = setTimeout(async () => {
        this.cartRefreshTimer = null;
        if (this.busy || this.preview || !this.isConnected || !this.loaded) return;
        this.cartRefreshPending = false;
        const updated = await this.loadCart();
        if (updated && this.isConnected && !this.busy) this.render();
      }, 120);
    }
    acceptCart(cart) {
      if (!cart || !Array.isArray(cart.items) || (cart.currency && cart.currency !== this.currency)) throw new Error('Cart unavailable');
      this.cartItems = cart.items;
      this.existing = cart.items.filter(line => this.eligible.has(id(line.product_id)) && cleanVendor(line.vendor) === 'liquimoly' && !line.selling_plan_allocation && !line.gift_card && Number.isSafeInteger(line.original_price) && line.original_price >= 0)
        .map(line => ({ ...line, id: id(line.variant_id || line.id), price: line.original_price, quantity: units(line.quantity) }));
      this.selection = new Map();
      this.existing.forEach(line => this.selection.set(line.id, (this.selection.get(line.id) || 0) + line.quantity));
      this.cartKnown = true;
    }
    loadCart() {
      if (this.cartRead) return this.cartRead;
      const lifecycle = this.controller;
      const request = (this.cartClient ? this.cartClient.read({ source: 'lm-catalog-read' }) : this.json(this.root + 'cart.js', { cache: 'no-store' })).then(cart => {
        if (lifecycle !== this.controller || lifecycle?.signal.aborted || !this.isConnected) return false;
        this.acceptCart(cart); return true;
      }).catch(() => {
        if (lifecycle !== this.controller || lifecycle?.signal.aborted || !this.isConnected) return false;
        this.cartKnown = false; this.status(this.t('cart_unavailable')); return false;
      }).finally(() => { if (this.cartRead === request) this.cartRead = null; });
      this.cartRead = request; return request;
    }
    async restore() { return this.preview ? undefined : this.loadCart(); }
    persist() { /* Quantities are persisted by Shopify, never in a staged bundle. */ }
    canSelect(variant) {
      if (!variant) return false;
      if (this.preview) return this.previewEligible.has(variant.product.id);
      return this.config.ready && this.manifestReady && this.eligible.has(variant.product.id) && variant.available === true && !variant.requiresSellingPlan && variant.price > 0;
    }
    currentVariant(view) {
      const option = this.currentContainer(view);
      return option?.variantId ? this.variants.get(option.variantId) : null;
    }
    changeServiceVehicle(event) {
      if (event.target !== this.service) return;
      if (!this.applyingGuideVehicle && this.service?.manual?.()) { this.liveGuide?.garageFieldChanged?.('make'); this.liveGuide?.invalidate?.(); }
      const acknowledgment = this.querySelector('[data-lm-manual-ack]'); if (acknowledgment) acknowledgment.checked = false;
      if (this.service?.manual?.() && this.vehicle) {
        this.liveGuide?.clear(); this.vehicle = null; this.category = 'all';
        this.service?.setVehicle?.(null);
        this.finderStatus(this.t('manual_oil_notice'));
      }
      if (this.loaded) this.render();
    }
    onChange(event) {
      if (event.target.matches('[data-lm-container-choice]')) { this.chooseContainer(event.target.dataset.productId, event.target.value); return; }
      if (event.target.matches('[data-lm-field]')) this.changeVehicleField(event.target.dataset.lmField);
      else if (event.target.matches('[data-lm-variant]')) this.render();
    }
    onClick(event) {
      const button = event.target.closest('button,a');
      if (!button || !this.contains(button)) return;
      if (button.matches('[data-lm-close-details]')) { this.querySelector('[data-lm-dialog]').close(); return; }
      if (button.matches('[data-lm-open-details]')) { if (!button.dataset.lmVehicleDestination && this.openDetails(button.closest('[data-lm-card]'), button)) event.preventDefault(); return; }
      if (button.matches('[data-lm-filter]')) { this.category = button.dataset.lmFilter; this.render(); return; }
      if (button.matches('[data-lm-clear-vehicle]')) { this.liveGuide?.garageFieldChanged?.('year'); this.service?.clearVehicle?.(); this.category = 'all'; if (this.liveGuide) this.liveGuide.clear(); else { this.vehicle = null; this.querySelector('[data-lm-vehicle-result]').hidden = true; this.render(); } return; }
      if (button.matches('[data-lm-summary-toggle]')) { this.summaryExpanded = !this.summaryExpanded; this.updateSummaryLayout(); return; }
      if (button.matches('[data-lm-cart-recheck]')) { this.recheckCart(); return; }
      if (button.matches('[data-lm-add],[data-lm-increase],[data-lm-decrease]')) {
        const card = button.closest('[data-lm-card],[data-lm-product-panel]');
        const variant = this.currentVariant(card);
        const decrement = button.matches('[data-lm-decrease]');
        if (!variant || (!decrement && (!this.canSelect(variant) || !selectionAllowed(this.vehicle, variant)))) return;
        this.changeQuantity(variant.id, decrement ? -1 : 1, undefined, { offerFilter: button.matches('[data-lm-add]') });
      }
      if (button.matches('[data-lm-line-increase],[data-lm-line-decrease]')) {
        const variant = this.variants.get(button.dataset.variantId);
        const decrement = button.matches('[data-lm-line-decrease]');
        if (!variant || (!decrement && (!this.canSelect(variant) || !selectionAllowed(this.vehicle, variant)))) return;
        this.changeQuantity(variant.id, decrement ? -1 : 1, button.dataset.lineKey);
      }
    }
    async recheckCart() {
      if (!this.cartClient || this.busy) return;
      try { const cart = await this.cartClient.acknowledge({ source: 'lm-catalog-review' }); this.acceptCart(cart); this.uncertain = false; this.status(this.t('cart_reviewed')); }
      catch { this.status(this.t('cart_unavailable')); }
      this.render();
    }
    async changeQuantity(variantId, delta, lineKey, options = {}) {
      if (this.busy || this.offerPending || this.uncertain || this.preview || !this.cartClient || !this.config.ready || !this.manifestReady || !this.cartKnown) return;
      const variant = this.variants.get(variantId);
      const line = lineKey ? this.existing.find(item => item.key === lineKey && item.id === variantId) : [...this.existing].reverse().find(item => item.id === variantId);
      if (!variant || (delta < 0 && !line)) return;
      const active = document.activeElement;
      const card = active?.closest('[data-lm-card],[data-lm-product-panel]');
      const initialContainer = this.containerChoices.get(variant.product.id);
      const sameProduct = () => { if (!this.isConnected || this.variants.get(variantId)?.sku !== variant.sku || initialContainer !== this.containerChoices.get(variant.product.id)) throw new Error(this.t('vehicle_changed')); };
      const offer = { withFilter: false, oilAcknowledged: false };
      try {
        if (delta > 0 && !lineKey && variant.product.category === 'oils' && (options.offerFilter ?? !line) && this.service?.requestOilFilter) {
          this.offerPending = true; this.render();
          const beforeVehicle = window.SacLmService.vehicleKey(this.service?.getVehicle?.() || this.vehicle);
          const currentCart = await this.cartClient.read({ source: 'lm-catalog-offer' });
          sameProduct();
          if (beforeVehicle !== window.SacLmService.vehicleKey(this.service?.getVehicle?.() || this.vehicle)) throw new Error(this.t('vehicle_changed'));
          const response = await this.service.requestOilFilter({ cart: currentCart, oilTitle: variant.product.title || '', oilMatched: !!recommendationFor(this.vehicle, variant) });
          sameProduct();
          if (!response || response.action === 'cancel') return;
          if (response.action !== 'with' && response.action !== 'without') throw new Error(this.t('vehicle_changed'));
          if (response.action === 'without' && beforeVehicle !== window.SacLmService.vehicleKey(this.service?.getVehicle?.() || this.vehicle)) throw new Error(this.t('vehicle_changed'));
          offer.withFilter = response.action === 'with'; offer.oilAcknowledged = response.oilAcknowledged === true;
          if (offer.oilAcknowledged) { const ack = this.querySelector('[data-lm-manual-ack]'); if (ack) ack.checked = true; }
          this.offerPending = false;
        }
        const vehicle = this.service?.getVehicle?.() || this.vehicle;
        if (delta > 0 && this.service?.manual?.() && !['fuel', 'engine'].includes(variant.product.category)) {
          if (!this.service.validate?.()) return;
          const acknowledgment = this.querySelector('[data-lm-manual-ack]');
          if (!acknowledgment?.checked) { this.status(this.t('manual_oil_ack_needed')); acknowledgment?.focus(); return; }
        }
        if (offer.withFilter && !this.service?.validate()) return;
        if (vehicle && !window.SacLmService?.buildVehicleProperties) { this.status(this.t('vehicle_changed')); return; }
        if (delta > 0 && additiveFor(vehicle, variant)?.state === 'incompatible') { this.status(this.t('additive_blocked')); return; }
        const properties = this.vehicleProperties(vehicle, variant, offer);
        const unchanged = () => {
          sameProduct();
          if (JSON.stringify(properties) !== JSON.stringify(this.vehicleProperties(this.service?.getVehicle?.() || this.vehicle, variant, offer))) throw new Error(this.t('vehicle_changed'));
          if (!['fuel', 'engine'].includes(variant.product.category) && this.service?.manual?.() && !this.querySelector('[data-lm-manual-ack]')?.checked) throw new Error(this.t('manual_oil_ack_needed'));
        };
        this.status(this.t('submitting'));
        let cart;
        if (delta < 0 || lineKey) {
          cart = await this.cartClient.change({ key: line.key, delta, source: 'lm-catalog' });
        } else {
          cart = await this.cartClient.add({ source: 'lm-catalog', prepare: async currentCart => {
            unchanged();
            await this.loadEligibility();
            if (!this.manifestReady || !this.eligible.has(variant.product.id) || !/^[a-z0-9][a-z0-9-]*$/.test(variant.product.handle || '')) throw new Error(this.t('manifest_error'));
            const fresh = await this.json(this.root + 'products/' + encodeURIComponent(variant.product.handle) + '.js', { cache: 'no-store' });
            if (id(fresh.id) !== variant.product.id || cleanVendor(fresh.vendor) !== 'liquimoly') throw new Error(this.t('submit_error'));
            const current = fresh.variants?.find(item => id(item.id) === variantId);
            if (!current || current.sku !== variant.sku || current.available !== true || current.price <= 0 || fresh.requires_selling_plan || current.requires_selling_plan) throw new Error(this.t('unavailable'));
            this.addProducts([fresh]);
            if (current.price !== variant.price) throw new Error(this.t('restored_changed'));
            unchanged();
            const items = [{ id: Number(variantId), quantity: delta, properties }];
            if (offer.withFilter) {
              const filter = await this.service.getLineItem(currentCart);
              filter.properties['Oil fitment'] = properties['Oil fitment'] || 'Needs team confirmation';
              if (properties['Oil fitment review']) filter.properties['Oil fitment review'] = properties['Oil fitment review'];
              items.push(filter);
            }
            unchanged();
            return items;
          } });
        }
        this.acceptCart(cart); this.status(this.t('cart_updated'));
      } catch (error) {
        this.uncertain = !!error.uncertain;
        this.status(error.uncertain ? this.t('submit_unknown') : error.message || this.t('submit_error')); 
      } finally {
        this.offerPending = false;
        if (this.isConnected) this.render();
        if (card && (active?.hidden || active?.closest('[hidden]'))) card.querySelector(this.selection.get(variantId) ? '[data-lm-increase]' : '[data-lm-add]')?.focus({ preventScroll: true });
        if (lineKey) this.querySelector('[data-lm-summary-title]')?.focus({ preventScroll: true });
      }
    }
    selectionLines() {
      return this.existing.map(line => {
        const variant = this.variants.get(line.id);
        return { ...variant, ...line, title: variant?.title || line.variant_title || '', product: variant?.product || { id: id(line.product_id), title: line.product_title || line.title, handle: line.handle }, price: line.original_price };
      });
    }
    renderProductLinks(card, variant, vehicle) {
      const href = window.SacLmAdditives?.productUrl?.(variant, vehicle, this.root);
      card.querySelectorAll('a.sac-lm__product-image,h3 a,a[data-lm-open-details]').forEach(link => {
        if (href) {
          if (!link.dataset.lmOriginalHref) link.dataset.lmOriginalHref = link.getAttribute('href');
          link.href = href; link.dataset.lmVehicleDestination = 'true';
        } else if (link.dataset.lmOriginalHref) {
          link.href = link.dataset.lmOriginalHref; delete link.dataset.lmOriginalHref; delete link.dataset.lmVehicleDestination;
        }
      });
    }
    renderApplication(node, text, result, vehicle) {
      const href = window.SacLmAdditives?.alternativeUrl?.(result, vehicle, this.root);
      if (!href && !node.lmApplicationText) { node.textContent = text; return; }
      if (!node.lmApplicationText) {
        node.lmApplicationText = document.createElement('span');
        node.lmApplicationLink = document.createElement('a');
        node.lmApplicationLink.dataset.lmAdditiveAlternative = '';
        node.replaceChildren(node.lmApplicationText, document.createTextNode(' '), node.lmApplicationLink);
      }
      node.lmApplicationText.textContent = text;
      node.lmApplicationLink.hidden = !href;
      if (href) { node.lmApplicationLink.href = href; node.lmApplicationLink.textContent = this.t(result.alternative.labelKey); }
      else node.lmApplicationLink.removeAttribute('href');
    }
    render() {
      const lines = this.selectionLines();
      const summary = totals([], this.preview ? [] : this.existing, this.tiers);
      if (this.cartKnown) {
        summary.total = this.existing.reduce((sum, line) => sum + (Number.isSafeInteger(line.final_line_price) && line.final_line_price >= 0 ? line.final_line_price : line.price * line.quantity), 0);
        summary.savings = Math.max(0, summary.subtotal - summary.total);
      }
      const canOperate = !this.busy && !this.offerPending && !this.uncertain && this.cartKnown && !this.preview && !!this.cartClient;
      const manualNotice = this.querySelector('[data-lm-manual-notice]'); if (manualNotice) manualNotice.hidden = !this.service?.manual?.();
      let visible = 0;
      const quick = this.config.compact ? this.quickProducts() : [];
      const shownQuick = this.vehicle ? quick : quick.slice(0, 3);
      const quickIds = new Set(shownQuick.map(row => row.product.id));
      this.querySelectorAll('[data-lm-card],[data-lm-product-panel]').forEach(card => {
        const product = this.products.get(card.dataset.productId);
        if (!product) return;
        const option = this.currentContainer(card), variant = this.currentVariant(card);
        if (!option) return;
        const rec = variant ? recommendationFor(this.vehicle, variant) : null;
        const additive = variant ? additiveFor(this.service?.getVehicle?.() || this.vehicle, variant) : null;
        this.renderProductLinks(card, variant, this.service?.getVehicle?.() || this.vehicle);
        const productMatches = !this.vehicle || product.variants.some(item => selectionAllowed(this.vehicle, this.variants.get(id(item.id))));
        if (card.matches('[data-lm-card]')) {
          card.dataset.category = product.category;
          card.hidden = this.config.compact ? !quickIds.has(product.id) : !productMatches || (this.category !== 'all' && card.dataset.category !== this.category);
          if (!card.hidden) visible++;
        }
        const selected = variant ? this.selection.get(variant.id) || 0 : 0;
        const image = card.querySelector('.sac-lm__product-image img');
        const imageUrl = this.safeImageUrl(option.contact ? option.image : variant?.image || option.image || product.image);
        if (image) {
          if (imageUrl && image.src !== imageUrl) {
            delete image.dataset.failedUrl;
            image.removeAttribute('srcset'); image.removeAttribute('sizes'); image.src = imageUrl;
            image.alt = [product.title, option.label].filter(Boolean).join(' · ');
          }
          image.hidden = !imageUrl || image.dataset.failedUrl === imageUrl;
          const placeholder = card.querySelector('[data-lm-image-unavailable]'); if (placeholder) placeholder.hidden = !image.hidden;
        }
        const sku = card.querySelector('[data-lm-sku]'); if (sku) sku.textContent = variant?.sku || option.sku || '';
        const source = card.querySelector('[data-lm-source]');
        const sourceUrl = option.sourceUrl || variant?.source_url || this.details.get(product.id)?.source_url || product.source_url;
        if (source) { source.hidden = !safeOfficialUrl(sourceUrl); if (!source.hidden) source.href = sourceUrl; }
        card.querySelectorAll('[data-lm-container-choice]').forEach(input => { input.checked = input.value === option.key; input.disabled = !canOperate; });
        const contact = card.querySelector('[data-lm-container-contact]'); if (contact) contact.hidden = !option.contact;
        const price = card.querySelector('[data-lm-price]');
        if (price) price.textContent = variant ? this.money(variant.price) : option.referencePrice ? new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: 'USD' }).format(option.referencePrice / 100) : this.t('contact_availability');
        const priceNote = card.querySelector('[data-lm-msrp-note]');
        if (priceNote) {
          priceNote.hidden = variant ? !this.preview : !option.referencePrice;
          priceNote.textContent = variant ? this.t('source_msrp') : this.t('manufacturer_reference_price');
        }
        const button = card.querySelector('[data-lm-add]');
        button.disabled = !canOperate || !variant || !this.canSelect(variant) || !selectionAllowed(this.vehicle, variant);
        button.hidden = selected > 0 || option.contact;
        button.firstChild.textContent = !this.preview && variant?.available !== true ? this.t('unavailable') + ' ' : this.t('add_selection') + ' ';
        const control = card.querySelector('[data-lm-quantity]'); control.hidden = selected === 0;
        card.querySelector('[data-lm-quantity-value]').textContent = this.t('in_cart_count', { count: selected });
        for (const direction of ['increase','decrease']) card.querySelector(`[data-lm-${direction}]`).setAttribute('aria-label', `${this.t(direction)}: ${product.title} · ${option.label}`);
        card.querySelector('[data-lm-increase]').disabled = !variant || !canOperate || selected >= 99 || !selectionAllowed(this.vehicle, variant);
        card.querySelector('[data-lm-decrease]').disabled = !canOperate;
        const application = card.querySelector('[data-lm-application]');
        application.dataset.application = additive?.state || (rec ? 'listed' : 'unknown');
        const applicationText = option.contact ? this.t('bulk_not_in_selection') : (this.service?.getVehicle?.() || this.vehicle) ? (additive ? [this.t('additive_state_' + additive.state), this.t(additive.reasonKey), additive.noticeKey ? this.t(additive.noticeKey) : ''].filter(Boolean).join(' · ') : rec ? [this.t('application_verified'), rec.application, rec.specification, rec.notes].filter(Boolean).join(' · ') : this.t('application_unverified')) : this.preview ? this.t('preview_application') : '';
        this.renderApplication(application, applicationText, option.contact ? null : additive, this.service?.getVehicle?.() || this.vehicle);
        if (variant) this.updateBadge(card, variant, summary.tier.percent);
        const badge = card.querySelector('sac-entry-badge'); if (badge && !variant) { badge.dataset.lmContactHidden = 'true'; badge.hidden = true; }
      });
      this.querySelectorAll('[data-lm-filter]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.lmFilter === this.category)));
      const empty = this.querySelector('[data-lm-empty]'); if (empty) empty.hidden = this.querySelectorAll('[data-lm-card]').length > 0;
      const noResults = this.querySelector('[data-lm-no-results]'); if (noResults) noResults.hidden = visible > 0 || !this.querySelectorAll('[data-lm-card]').length;
      if (this.config.compact) {
        const heading = this.querySelector('[data-lm-catalog-heading]');
        if (heading) heading.textContent = this.t(this.vehicle ? 'home_matching_heading' : 'home_oils_heading');
        const count = this.querySelector('[data-lm-quick-count]');
        if (count) count.textContent = quick.length ? this.t(quick.length === 1 ? 'home_showing_one' : 'home_showing', { quantity: shownQuick.length, count: quick.length }) : '';
        if (noResults) noResults.textContent = this.t(this.vehicle ? 'home_none' : 'no_results');
        this.querySelectorAll('[data-lm-home-continue],[data-lm-continue]').forEach(link => { link.href = vehicleDestination(this.config.destination, this.vehicle, this.fieldValues()); });
        const label = this.querySelector('[data-lm-home-continue-label]');
        if (label) label.textContent = this.t(this.vehicle ? 'home_view_all' : 'home_build');
      }
      this.querySelector('[data-lm-summary-title]').textContent = this.t('selected_count', { count: summary.count });
      this.updateSavings(summary);
      this.querySelector('[data-lm-subtotal]').textContent = this.money(summary.subtotal);
      this.querySelector('[data-lm-saving]').textContent = '−' + this.money(summary.savings);
      const filterLines = (this.cartItems || []).filter(line => id(line.product_id) === id(this.config.filterProductId) && !line.selling_plan_allocation);
      const filterTotal = filterLines.reduce((sum, line) => sum + (Number.isSafeInteger(line.final_line_price) ? line.final_line_price : line.original_price * line.quantity), 0);
      const filterRow = this.querySelector('[data-lm-filter-total-row]');
      if (filterRow) { filterRow.hidden = !filterLines.length; filterRow.querySelector('[data-lm-filter-total]').textContent = this.money(filterTotal); }
      this.querySelector('[data-lm-total]').textContent = this.money(summary.total + filterTotal);
      this.querySelector('[data-lm-cart-context]').textContent = this.cartKnown ? this.t('cart_context', { count: summary.count }) : this.t('cart_unavailable');
      this.renderSelection(lines);
      const recheck = this.querySelector('[data-lm-cart-recheck]'); if (recheck) { recheck.hidden = !this.uncertain && this.cartKnown; recheck.disabled = this.busy; }
      const mobileCount = this.querySelector('[data-lm-mobile-count]');
      if (mobileCount) {
        mobileCount.textContent = this.t('mobile_count', { count: summary.count });
        this.querySelector('[data-lm-mobile-discount]').textContent = summary.tier.percent ? this.t('mobile_discount', { percent: summary.tier.percent }) : this.t('savings_locked');
        this.querySelector('[data-lm-mobile-next]').textContent = summary.next ? this.t('mobile_next', { quantity: summary.next.quantity - summary.count, percent: summary.next.percent }) : this.t('mobile_max');
      }
    }
    updateSavings(summary) {
      const next = summary.next ? this.t('next_tier', { quantity: summary.next.quantity - summary.count, percent: summary.next.percent }) : this.t('max_tier');
      this.querySelectorAll('[data-lm-next]').forEach(node => { node.textContent = next; });
      this.querySelectorAll('[data-lm-unlock-title]').forEach(node => { node.textContent = summary.tier.percent ? this.t('savings_unlocked', { percent: summary.tier.percent }) : this.t('savings_start'); });
      this.querySelectorAll('[data-lm-unlock]').forEach(node => { node.classList.toggle('is-unlocked', summary.tier.percent > 0); });
      this.querySelectorAll('[data-lm-progress]').forEach(node => { node.style.width = unlockProgress(summary.count, this.tiers) + '%'; });
      this.querySelectorAll('[data-lm-progressbar]').forEach(node => {
        const tiers = this.tiers || TIERS;
        node.setAttribute('aria-valuemax', tiers[tiers.length - 1].quantity);
        node.setAttribute('aria-valuenow', Math.min(tiers[tiers.length - 1].quantity, summary.count));
        node.setAttribute('aria-valuetext', this.t('savings_state', { count: summary.count, percent: summary.tier.percent }));
      });
      this.querySelectorAll('[data-lm-tier],[data-lm-mobile-tier]').forEach(node => {
        const threshold = Number(node.dataset.lmTier || node.dataset.lmMobileTier);
        node.classList.toggle('is-current', threshold === summary.tier.quantity);
        node.classList.toggle('is-unlocked', summary.count >= threshold);
        if (node.dataset.lmTier) node.setAttribute('aria-current', threshold === summary.tier.quantity ? 'step' : 'false');
      });
      const announcement = this.querySelector('[data-lm-unlock-status]');
      if (announcement && this.lastAnnouncedTier !== summary.tier.percent) {
        if (this.lastAnnouncedTier !== undefined) announcement.textContent = summary.tier.percent ? this.t('savings_unlocked', { percent: summary.tier.percent }) + '. ' + next : this.t('savings_start') + '. ' + next;
        this.lastAnnouncedTier = summary.tier.percent;
      }
    }
    updateBadge(card, variant, percent) {
      const badge = card.querySelector('sac-entry-badge');
      if (!badge || this.preview) return;
      const cartLine = this.existing.find(line => line.id === variant.id && Number.isSafeInteger(line.final_price) && line.final_price >= 0);
      const price = cartLine ? cartLine.final_price : variant.price;
      if (!badge.dataset.lmContactHidden && badge.dataset.priceMin === String(price) && badge.dataset.priceMax === String(price)) return;
      const fresh = badge.cloneNode(true); delete fresh.dataset.lmContactHidden; fresh.dataset.priceMin = price; fresh.dataset.priceMax = price; fresh.hidden = true; badge.replaceWith(fresh);
    }
    renderSelection(lines) {
      const target = this.querySelector('[data-lm-selection-list]');
      if (!target) return;
      const signature = JSON.stringify([this.busy, this.uncertain, this.vehicle?.id, lines.map(line => [line.key, line.quantity, line.price, line.product.title, line.title, line.properties])]);
      if (this.renderedCartList === target && this.renderedCartSignature === signature) return;
      target.replaceChildren();
      lines.forEach(variant => {
        const row = document.createElement('li'); row.className = 'sac-lm__selected-line';
        const copy = document.createElement('div'); copy.textContent = variant.product.title;
        const sub = document.createElement('small'); sub.textContent = [variant.title === 'Default Title' ? '' : variant.title, this.money(variant.price)].filter(Boolean).join(' · '); copy.append(sub);
        if (variant.properties?.Vehicle) { const vehicle = document.createElement('small'); vehicle.textContent = variant.properties.Vehicle; copy.append(vehicle); }
        if (this.vehicle && !selectionAllowed(this.vehicle, variant)) { const note = document.createElement('small'); note.className = 'sac-lm__selection-warning'; note.textContent = this.t('selection_not_matched'); copy.append(note); }
        const controls = document.createElement('div'); controls.className = 'sac-lm__selected-controls';
        for (const direction of ['decrease','increase']) {
          const button = document.createElement('button'); button.type = 'button'; button.dataset[direction === 'decrease' ? 'lmLineDecrease' : 'lmLineIncrease'] = ''; button.dataset.variantId = variant.id; button.dataset.lineKey = variant.key; button.textContent = direction === 'decrease' ? '−' : '+'; button.setAttribute('aria-label', `${this.t(direction)}: ${variant.product.title} · ${variant.title}`); button.disabled = this.busy || this.uncertain || (direction === 'increase' && variant.quantity >= 99);
          if (direction === 'increase') { button.disabled = button.disabled || !selectionAllowed(this.vehicle, variant); const count = document.createElement('output'); count.textContent = variant.quantity; controls.append(count); }
          controls.append(button);
        }
        row.append(copy,controls); target.append(row);
      });
      this.renderedCartList = target; this.renderedCartSignature = signature;
    }
  }
  customElements.define('sac-liqui-moly', SacLiquiMoly);
})();
